import {RecommendationClause, RecommendationClauseShort} from './recommendation-clause';
import {Question} from './question';
import {ExplanationFull, ExplanationShort} from './explanation';

export class Recommendation {
  constructor(public clauses : RecommendationClause[],
              public explanations: ExplanationFull[],
              public type: string,
              public id? : string,
              public description?: string) {}

  useQuestion(q : Question) : boolean {
    return this.clauses.some(c => c.useQuestion(q));
  }

  isValid() {
    return this.type &&
      this.clauses &&
      this.clauses.length > 0 &&
      this.clauses.every(r => r.isValid()) &&
      this.explanations &&
      this.explanations.length > 0 &&
      this.explanations.every(e => e.isValid(this.clauses));
  }
  equals(other : Recommendation) : boolean {
    return this.type == other.type && this.clauses == other.clauses && this.explanations == other.explanations;
  }
}

export class RecommendationShort {
  constructor(
    public type: string,
    public clauses: RecommendationClauseShort[],
    public explanations: ExplanationShort[],
    public description?: string){}
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/model/recommendation.ts